import React, { Component } from "react";
import { getDb, setDb, sendArrayDb } from "../C18AiUtils";
import { globs } from "../../../components/utils/utils";

const CHAN = 255;
const TAB = "zone_configuration_settings";
const VOL_UNIT_COLUMN = "Volume Measurement Units"
const TMP_UNIT_COLUMN = "Temperature Units"

const ROW = 0;

function toDisplay(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
}

export default class DoserSystemSettings extends Component {
  state = {
    volUnits: "",
    tmpUnits: "",
//     ecSp: "",
//     ecCal: "",
//     phSp: "",
//     phCal: "",
  };

  componentDidMount() {
    const { zInd, vUnitId, tUnitId } = this.props;
    this.setState({
      volUnits: vUnitId,//+getDb(zInd, CHAN, TAB, VOL_UNIT_COLUMN, ROW) ?? "",
      tmpUnits: tUnitId,//+getDb(zInd, CHAN, TAB, TMP_UNIT_COLUMN, ROW) ?? "",
//       ecSp: toDisplay(getDb(zInd, CHAN, TAB, "dose_ec_sp", ROW)),
//       ecCal: toDisplay(getDb(zInd, CHAN, TAB, "dose_ec_cal", ROW)),
//       phSp: toDisplay(getDb(zInd, CHAN, TAB, "dose_ph_sp", ROW)),
//       phCal: toDisplay(getDb(zInd, CHAN, TAB, "dose_ph_cal", ROW)),
    });
    this.subscribe_savePageEvent = globs.events.subscribe("savePageEvent", this.savePage);
  }

  componentWillUnmount() {
    if (this.subscribe_savePageEvent && this.subscribe_savePageEvent.remove) {
      this.subscribe_savePageEvent.remove();
    }
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value });

    globs.events.publish("savePageEnable", true);
  };

  savePage = async () => {
    const { volUnits, tmpUnits } = this.state;
    const { zInd,onChange } = this.props;

    let arr = [];

//     const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
//     const toNum = (v, fallback = 0) => {
//       const n = Number(v);
//       return Number.isFinite(n) ? n : fallback;
//     };
//     const round2 = (v) => Math.round(v * 100) / 100;

//     const units = Math.round(clamp(toNum(kFact, 0), 0, 10000));

    setDb(arr, zInd, CHAN, TAB, VOL_UNIT_COLUMN, ROW, volUnits);
    setDb(arr, zInd, CHAN, TAB, TMP_UNIT_COLUMN, ROW, tmpUnits);
    onChange([
      {type:"vUnitId",value:+volUnits},
      {type:"tUnitId",value:+tmpUnits},])

    await sendArrayDb(arr);
  };

  render() {
    const { volUnits, tmpUnits } = this.state;

    const labelStyle = {
      fontSize: 12,
      color: "#666",
      display: "block",
      marginBottom: 6,
    };
    const inputStyle = {
//       width: "100px",
      boxSizing: "border-box",
      borderRadius: 10,
      padding: "8px",
    };

    let volUnitSelVals=[
      "Liters and Milliliters (L/ml)",
      "Gallons and Ounces (gal/oz)",
      "Gallons and Milliliters (gal/ml)"
    ]
    let tmpUnitSelVals=[
      "Fahrenheit",
      "Celsius",
    ]
    var makeOpts=(vals)=>{
      return vals.map((u,i)=><option key={i} value={i}>{u}</option>)
    }
    let volUnitOpts=makeOpts(volUnitSelVals)
      .map((u,i)=><option key={i} value={i}>{u}</option>)



    return (
      <div
        style={{
          fontFamily: "system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
          padding: 8,
        }}
      >
      <h3>System Settings</h3>
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>Volume Units</label>
          <select
            style={inputStyle}
            value={volUnits}
            onChange={e=>this.handleChange("volUnits",e.target.value)}
          >
            {makeOpts(volUnitSelVals)}
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>Temperature Units</label>
          <select
            style={inputStyle}
            value={tmpUnits}
            onChange={e=>this.handleChange("tmpUnits",e.target.value)}
          >
            {makeOpts(tmpUnitSelVals)}
          </select>
        </div>
      </div>
    );
  }
}
